import React, { useCallback, useEffect, useState } from "react";
import { get, set, useChangeTrackingLens } from "@totalsoft/change-tracking-react";
import { useQueryWithErrorHandling } from "hooks/errorHandling";
import { QUOTES_QUERY } from "../queries";
import QuoteListFilters from "./QuoteListFilters";
import { QuoteOrderByList, InitialQuoteList, InitialQuoteFilter } from "../constants";
import InfiniteScroll from "react-infinite-scroll-component";
import Quote from "./Quote";
import { useLocation } from "react-router";
import { addToast } from "components/notifications";
import { useTranslation } from "react-i18next";
import { emptyArray } from "constants/defaultValues";
import { quotesContainer } from "../styles";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(quotesContainer);

const getOrderByBdFieldName = (orderById) => QuoteOrderByList.find((x) => x.id === orderById).dbFieldName;

function QuoteList() {
  const { t } = useTranslation();
  const classes = useStyles();
  const location = useLocation();
  const [filterLens] = useChangeTrackingLens(InitialQuoteFilter);
  const filter = filterLens |> get;
  const [quoteList, setQuoteList] = useState(InitialQuoteList);

  useEffect(() => {
    if (location.state?.message) addToast(location.state.message, "success");
    if (location.state?.errorMessage) addToast(location.state.errorMessage, "warning");
  }, [t, location]);

  const { loading } = useQueryWithErrorHandling(QUOTES_QUERY, {
    variables: {
      page: filter.page,
      pageSize: filter.pageSize,
      freeTxt: filter.keyword,
      responsibleId: filter.responsibleId,
      requiredById: filter.requiredById,
      orderBy: getOrderByBdFieldName(filter.orderById),
    },
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      setQuoteList((prev) => ({
        totalCount: data.quotes?.totalCount || 0,
        totalPages: data.quotes?.totalPages || 0,
        values: data.quotes
          ? data.quotes?.page == 1
            ? [...data.quotes?.values]
            : [...prev.values, ...data.quotes?.values]
          : emptyArray,
      }));
    },
  });

  const resetFullListOnSearch = useCallback(() => {
    if (loading) return;
    filter.page != 1 && setQuoteList(InitialQuoteList);
    (filterLens.page |> set)(1);
  }, [loading, filterLens.page, filter.page]);

  const fetchMoreData = useCallback(() => {
    (filterLens.page |> set)(filter.page + 1);
  }, [filterLens, filter]);

  return (
    <div className={classes.container}>
      <QuoteListFilters
        quoteList={quoteList}
        filter={filter}
        filterLens={filterLens}
        resetFullListOnSearch={resetFullListOnSearch}
        loadingList={loading}
      />
      <InfiniteScroll
        dataLength={quoteList.values.length}
        next={fetchMoreData}
        style={{ flexDirection: "column-reverse", height: "calc(100vh - 72.42px - 102px)" }}
        hasMore={filter.page < quoteList.totalPages}
        scrollThreshold={"100px"}
        height={800}
      >
        {quoteList.values.map((item, idx) => (
          <Quote key={item.quoteId} quoteId={item.quoteId} idx={idx} setQuoteList={setQuoteList} />
        ))}
      </InfiniteScroll>
    </div>
  );
}

export default QuoteList;
